import { type ComponentProps } from 'react';
import { Icon } from '@plone/components';
import iconSVGs from '@redturtle/qubicaamf-theme/helpers/ctaIconsHelper';

interface CtaIconProps extends Omit<ComponentProps<typeof Icon>, 'children'> {
  iconValue?: string;
}

const CtaIcon = (props: CtaIconProps) => {
  const { iconValue } = props;
  const icon = iconSVGs.find((el) => el.icon === iconValue);
  return icon?.iconSvg ? (
    <Icon size="M" aria-hidden={true} {...props}>
      {icon.iconSvg}
    </Icon>
  ) : (
    <></>
  );
};

export default CtaIcon;
